import styled from 'styled-components';
import { desktop_container_maxwidth } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const LandItTermsStyles = styled.div`
  padding: 25px 15px 25px;

  .terms-container {
    max-width: ${desktop_container_maxwidth}px;
    margin: 0 auto;

    a {
      text-decoration: none;
    }

    h1,
    h3,
    p {
      padding-bottom: 10px;
    }
    p {
      font-size: 14px;
      line-height: initial;
    }
  }
`;

export default LandItTermsStyles;
